import React, { useRef, useState } from "react";
import styles from './styles';
import {
  makeStyles,
  Dialog,
  Link,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { getI18n } from '../../../../utils/intl.js'
import { useIntl } from 'react-intl';
import ListContainer from '../../../../pages/list';
import ClientDefinitionDetails from './ClientDefinition/index';

const ListAuthProviderClientDefinitions = ({
  definitions = [],
  authProviderUuid,
  isLoadingDefinitions,
  refreshClientDefinitionsCallback,
}) => {
  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const selectedClientDefinition = useRef(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const canAddDefintion = true; // hasCRUDPermissions(user, ['CREATE'], API_KEYS_APPLICATION);
  const columns = [
  {
    id: 'name',
    label: intl.getI18nMessage('label.auth.providers.details.sample.client.definitions.name'),
    minWidth: 100,
    value: ((row) => <Link underline="none" href="#" className={classes.linkHover} onClick={() => handleDefinitionOnClick(row)}>{row.name}</Link>),
  },
  {
    id: 'description',
    label: intl.getI18nMessage('label.auth.providers.details.sample.client.definitions.description'),
    minWidth: 350,
    value: ((row) => row.description),
    },
  ];

  const handleAddNewDefinition = () => {
    selectedClientDefinition.current = null;
    setIsDialogOpen(true);
  };

  const handleDefinitionOnClick = (row) => {
    selectedClientDefinition.current = row;
    setIsDialogOpen(true);
  }

  const handleDialogClose = (refreshList) => {
    setIsDialogOpen(false);
    // do explicit check to prevent refresh when closing
    // by clicking outside overlay, in which case refreshList
    // will be event and not boolean we set while calling.
    if (refreshList === true) {
        refreshClientDefinitionsCallback();
    }
  }

  const dialog = (
  <Dialog
      open={isDialogOpen}
      onClose={handleDialogClose}
      aria-labelledby="client-definition-dialog"
      id={"client-definition-dialog"}
      classes={{ paper: classes.paperClass }}
      maxWidth={'xl'}
    >
    <ClientDefinitionDetails
      definition={selectedClientDefinition.current}
      authProviderUuid={authProviderUuid}
      onClose={handleDialogClose}
    />
  </Dialog>
);

  return (
  <div id="list-client-definitions">
    {dialog}
    <ListContainer
        // userContext={userContext}
        pageHeaderTitle={" "}
        showListHeader={true}
        hasPaginationDisabled={true}
        columns={columns}
        rows={definitions}
        listPageId="client-definitions-list"
        isLoading={isLoadingDefinitions}
        addButtonLabel={intl.getI18nMessage('label.auth.providers.details.sample.client.definition.add')}
        onAdd={canAddDefintion && handleAddNewDefinition}
        disableAdd={!canAddDefintion}
        hideFooter={true}
        hidePagination={true}
        noResultsMessage={intl.getI18nMessage('label.auth.providers.details.sample.client.definitions.empty')}
    />
  </div>
  );
}

ListAuthProviderClientDefinitions.propTypes = {
    definitions: PropTypes.arrayOf(PropTypes.object),
    authProviderUuid: PropTypes.string,
    isLoadingDefinitions: PropTypes.bool,
    refreshClientDefinitionsCallback: PropTypes.func,
};

export default ListAuthProviderClientDefinitions;